import classNames from 'classnames';
import xss from 'utils/xss';
import styles from './StorePageBannerDescription.module.scss';

function StorePageBannerDescription({
  body: descriptionBody,
  alignment: descriptionAlignment,
  header,
} = {}) {
  const contentAlignment =
    descriptionAlignment && descriptionAlignment === 'Left'
      ? `align-items-left justify-content-left text-left`
      : `align-items-center justify-content-center text-center`;

  return descriptionBody ? (
    <section className={classNames(styles.section)}>
      <div
        className={classNames(
          'd-flex flex-column text-primary w-100 pt-15 px-16 py-lg-30',
          contentAlignment,
          styles.content
        )}
      >
        {header && <h1 className={styles.header}>{header}</h1>}
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: xss(descriptionBody) }}
          className={classNames(contentAlignment, styles.body)}
        />
      </div>
    </section>
  ) : null;
}

export default StorePageBannerDescription;
